/* @flow */

import { Request } from "shared/src/services/Requests";

const RequestBuilder = new Request.Builder("searchdiscover", "searchcockpit", true);

export type RelevanceJudgmentInput = {
    country: string;
    locale: string;
    query: string;
    articleVariantId: string;
    judgment: number;
};

export function postRelevanceJudgment(judgment: RelevanceJudgmentInput): Promise<any> {
    const url = "/judgments";
    return RequestBuilder.path(url, {}).body(judgment).retry().post();
}
